// @flow

import { createSelector } from 'reselect';

import { selectFromConfig } from '@gandi/redux-config';
import { selectIsPrivilegedUser } from '@gandi/authentication';
import { localeSelector } from '@gandi/translate';

import type { FullState } from '../types';

type FlagSelector = (state: FullState) => boolean;

type SelectFeatureFlagUrlArgs = {|
  featureFlagName: string,
|};

/**
 * Retrieve the value of a feature flag.
 * Usage:
 * selectFeatureFlag(state, { featureFlagName: 'SHOW_NEW_REDIRECTIONS' })
 */
/* eslint-disable import/prefer-default-export */
export const selectFeatureFlag: (
  state: FullState,
  props: SelectFeatureFlagUrlArgs
) => boolean = createSelector(
  [selectFromConfig('flags', {}), selectIsPrivilegedUser, (_, props) => props],
  (flags, isPrivileged, { featureFlagName }) =>
    !!flags[featureFlagName] || isPrivileged
);

export const selectFlagByLang: (
  state: FullState,
  props: SelectFeatureFlagUrlArgs
) => boolean = createSelector(
  [
    selectFromConfig<{ [string]: string }>('flagsByLang', {}),
    localeSelector,
    (_, props) => props,
  ],
  (flags, locale, { featureFlagName }) =>
    !!flags[featureFlagName] && flags[featureFlagName].includes(locale)
);

export const selectShowVPSFormCategory: FlagSelector = state =>
  selectFeatureFlag(state, {
    featureFlagName: 'SHOW_VPS_FORM_CATEGORY',
  });
